import { QuickfireStartRound } from "quickfire/commands/quickfire-start-round-command";
import quickfireModel from "quickfire/model/quickfire-model";
import betModel from "slotworks/model/bets/bet-model";
import gameState from "slotworks/model/game-state";
import RequestSpin from "slotworks/state-machine/standard/states/request-spin";
import QuickfireFreeGamesComponent from "../components/quickfire-free-games-component";

export default class QuickfireRequestSpin extends RequestSpin {

    public onEnter(cascadeSkip?: boolean) {

        const cantAffordSpin = !quickfireModel.playingFreeGames && gameState.getCurrentGame().balance < betModel.getTotalStake();

        if (cantAffordSpin) {
            return this.showInsufficientFundsDialog();
        }

        QuickfireStartRound();

        QuickfireFreeGamesComponent.spin();

        super.onEnter(cascadeSkip);
    }

    private showInsufficientFundsDialog() {
        V.API.Core.displayInsufficientFunds();
        super.error();
    }
}
